import React from 'react';
import {useTranslation} from 'react-i18next';
import {Info, ShieldCheck} from '../icons';

/**
 * Las dos caras del MISMO aviso. Un solo componente y un solo cambio: si la agencia lee lo que su
 * cliente pregunta, el cliente tiene que saberlo — **no se puede deployar una variante sin la otra**.
 *
 * - `variant="agency"` encabeza el bloque de preguntas en la ficha del cliente.
 * - `variant="client"` va en el portal del cliente, en la pantalla donde conecta su IA, que es el
 *   momento del consentimiento y no unos términos enterrados.
 *
 * No se puede descartar ni cerrar. Un aviso que se oculta con una equis deja de existir a los dos
 * días, y el compromiso con el cliente no dura dos días.
 */
export function PortalPrivacyNotice({variant = 'agency'}) {
    const {t} = useTranslation();

    if (variant === 'client') {
        return (
            <div className="pu-notice -info">
                <Info size={17}/>
                <span>
                    <b>{t('portal_usage.privacy_client_title', 'Qué ve tu agencia.')}</b>{' '}
                    {t('portal_usage.privacy_client_text',
                        'Tu agencia puede ver las consultas que haces con el asistente, para entender qué '
                        + 'necesitas y ayudarte mejor. Se registran la pregunta, la fecha y los datos '
                        + 'consultados. No se registran tus credenciales ni el contenido de tus '
                        + 'conversaciones fuera de Dashbo.')}
                </span>
            </div>
        );
    }

    return (
        <div className="pu-notice -info">
            <ShieldCheck size={17}/>
            <span>
                {t('portal_usage.privacy_agency_text',
                    'Estas son las consultas que hizo tu cliente desde el asistente. Él lo sabe: se lo '
                    + 'decimos en su portal, en la misma pantalla donde conecta su IA.')}{' '}
                <b>{t('portal_usage.privacy_agency_warning', 'No compartas el contenido fuera del equipo.')}</b>
            </span>
        </div>
    );
}

export default PortalPrivacyNotice;
